
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    isCart: { type: Boolean, default: false },
    redeemed_discount: { type: Object, default: () => {} },
  },
  components: {
    modalPWPDetail: async () =>
      await import('@/components/pwp/modalPWPDetail.vue'),
  },
  data() {
    return {
      itemsPWP: [],
      overlayImagesItemsPromotion: [],
      categoryId: '61409939e55b97a588fd96fc',
      used: 0,
      total: 10,
      head_title: '',
      head_desc: '',
      toastData: {
        title: '',
        desc: '',
      },
    }
  },
  computed: {
    ...mapGetters('authen', ['openId']),
    ...mapGetters('user', ['userProfile', 'profileType', 'userCostcenter']),
    ...mapGetters('cart', ['cartId']),
  },
  watch: {
    redeemed_discount: {
      handler: function (val) {
        if (
          val?.toast_message?.title?.[this.$i18n.locale] &&
          val?.toast_message?.description?.[this.$i18n.locale]
        ) {
          // if (
          //   this.head_title !== val.toast_message.title[this.$i18n.locale] ||
          //   this.head_desc !== val.toast_message.description[this.$i18n.locale]
          // ) {
          this.head_title = val.toast_message.title[this.$i18n.locale]
          this.head_desc = val.toast_message.description[this.$i18n.locale]
          this.onToast(this.head_title, this.head_desc)
          // }
        } else {
          // this.head_title = ''
          // this.head_desc = ''
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    await this.getPWPRedemptionPage()

    // if (
    //   this.redeemed_discount?.toast_message?.title?.[this.$i18n.locale] &&
    //   this.redeemed_discount?.toast_message?.description?.[this.$i18n.locale]
    // ) {
    //   this.head_title =
    //     this.redeemed_discount.toast_message.title[this.$i18n.locale]
    //   this.head_desc =
    //     this.redeemed_discount.toast_message.description[this.$i18n.locale]
    //   this.onToast(this.head_title, this.head_desc)
    // }
  },
  methods: {
    // onTestUpdateToast() {
    //   if (this.redeemed_discount?.toast_message) {
    //     this.head_title =
    //       this.redeemed_discount.toast_message.title[this.$i18n.locale]
    //     this.head_desc =
    //       this.redeemed_discount.toast_message.description[this.$i18n.locale]
    //     this.onToast(this.head_title, this.head_desc)
    //   }
    // },
    async getPWPRedemptionPage() {
      const params = new URLSearchParams()
      params.append('account_channel', this.profileType)
      params.append('account_id', this.userProfile.id)
      params.append('user_category_type', 'Standard')

      params.append('page', 1)
      params.append('page_size', 20)
      let responsed = await this.$productProvider.getPWPRedemptionPage(
        this.redeemed_discount.id,
        params
      )
      console.log('PWPParticipatingPage', responsed)
      if (responsed.status === 200) {
        this.itemsPWP = responsed.data.items
      }
    },
    // onToast(toast_title, toast_desc) {
    //   const id = 'pwp-toast-cart'

    //   // Track toast state in the component instance
    //   // if (!this.toastData) {
    //   //   this.toastData = this.$root.$data.toastData =
    //   //     this.$root.$data.toastData ||
    //   //     this.$set(this.$root.$data, 'toastData', {
    //   //       title: title,
    //   //       desc: desc,
    //   //     })
    //   // } else {
    //   //   // Update values
    //   //   this.toastData.title = title
    //   //   this.toastData.desc = desc
    //   // }

    //   this.toastData.title = toast_title
    //   this.toastData.desc = toast_desc
    //   // Check if toast is currently visible
    //   const existingToast = document.getElementById(id)

    //   // If toast is NOT visible, show it again
    //   if (!existingToast) {
    //     const headerContent = this.$createElement({
    //       data: () => this.toastData,
    //       render(h) {
    //         return h(
    //           'div',
    //           {
    //             class: 'd-flex align-items-center justify-content-between',
    //             attrs: { id },
    //           },
    //           [
    //             h('div', { class: 'd-flex' }, [
    //               h('div', { class: 'head-pwp-toast' }, [
    //                 h('div', { class: 'flex-center 56px' }, [
    //                   h('img', {
    //                     attrs: {
    //                       src: 'https://ofm-cdn0.ofm.co.th/images/pwp-icons.png',
    //                       width: '36px',
    //                       height: '36px',
    //                     },
    //                   }),
    //                 ]),
    //               ]),
    //               h('div', { class: 'head-pwp-body' }, [
    //                 h('div', { class: 'fs-14 fw-bold' }, [this.title]),
    //                 h('div', { class: 'fs-11' }, [this.desc]),
    //               ]),
    //             ]),
    //             h('b-icon-x', {
    //               class: ['ml-auto mb-auto m-1 fs-20 pointer'],
    //               on: {
    //                 click: () => {
    //                   this.$bvToast.hide(id)
    //                 },
    //               },
    //             }),
    //           ]
    //         )
    //       },
    //     })

    //     this.$bvToast.toast([headerContent], {
    //       id,
    //       append: false,
    //       // noAutoHide: true,
    //       toaster: 'b-toaster-top-right pwp-toast',
    //       noCloseButton: true,
    //       autoHideDelay: 5000,
    //     })
    //   }
    // },
    onToast(title, desc) {
      const id = 'pwp-toast'

      // Update toast data
      this.toastData.title = title
      this.toastData.desc = desc

      // If toast is visible, hide it first
      const existingToast = document.getElementById(id)
      if (existingToast) {
        this.$bvToast.hide(id) // hide current one
        setTimeout(() => this.showToast(id), 10) // slight delay to re-show
      } else {
        this.showToast(id)
      }
    },

    showToast(id) {
      const toastData = this.toastData

      const headerContent = this.$createElement({
        data() {
          return toastData
        },
        render(h) {
          return h(
            'div',
            {
              class: 'd-flex align-items-center justify-content-between',
              attrs: { id },
            },
            [
              h('div', { class: 'd-flex' }, [
                h('div', { class: 'head-pwp-toast' }, [
                  h('div', { class: 'flex-center 56px' }, [
                    h('img', {
                      attrs: {
                        src: 'https://ofm-cdn0.ofm.co.th/images/pwp-icons.png',
                        width: '36px',
                        height: '36px',
                      },
                    }),
                  ]),
                ]),
                h('div', { class: 'head-pwp-body' }, [
                  h('div', { class: 'fs-14 fw-bold' }, [this.title]),
                  h('div', { class: 'fs-11' }, [this.desc]),
                ]),
              ]),
              h('b-icon-x', {
                class: ['ml-auto mb-auto m-1 fs-20 pointer'],
                on: {
                  click: () => this.$bvToast.hide(id),
                },
              }),
            ]
          )
        },
      })

      this.$bvToast.toast([headerContent], {
        id,
        append: false,
        toaster: 'b-toaster-top-right pwp-toast',
        noCloseButton: true,
        autoHideDelay: 5000, // Reset on each call
      })
    },
  },
}
